/* global BMap, BMapGL */

const CHINA_CENTER = new BMap.Point(113.216596, 22.913121);

export class MapController {
    mapId;
    map;

    isPolyline = true;

    routes = new Map();

    overlays = new Map();

    drivings = new Map();

    // 保存地图上画出的所有坐标，用于适配地图缩放 viewport
    viewportPoints = new Map();

    eventListener = new Map();

    constructor(mapId, { isPolyline = true }) {
        this.mapId = mapId;
        this.isPolyline = isPolyline;
    }

    // 初始化地图
    initMap() {
        const map = new BMapGL.Map(this.mapId, { enableMapClick: false });
        this.map = map;

        map.centerAndZoom(CHINA_CENTER, 6);
        map.enableScrollWheelZoom(true);
        map.setMaxZoom(20);

        // let points = [];
        // let polyline;
        // map.addEventListener('click', e => {
        //     polyline && map.removeOverlay(polyline);
        //
        //     console.log(e.point);
        //     points.push(new BMap.Point(e.point.lng, e.point.lat));
        //
        //     console.log('points ->', points);
        //
        //     polyline = new BMap.Polyline(points);
        //     console.log(JSON.stringify(points.map(p => ({ lng: p.lng, lat: p.lat }))));
        //     map.addOverlay(polyline);
        // });
    }

    /// 添加时间处理
    on(eventName, listener) {
        this.eventListener.set(eventName, listener);
    }

    _fire(eventName, ...params) {
        const l = this.eventListener.get(eventName);
        if (l) {
            l(...params);
        }
    }

    /// 切换直线/路径模式
    switchPolylineMode(isPolyline) {
        if (this.isPolyline !== isPolyline) {
            this.isPolyline = isPolyline;

            // 重绘所有路径
            for (const [id, params] of this.routes.entries()) {
                this.addRoute(id, params.start, params.points, params.options);
            }
        }
    }

    /// 画路径
    addRoute(id, start, taskPoints, options = { color: 'green' }) {
        // 去掉无效点
        const points = taskPoints.filter(p => p && p.lng && p.lat);

        // 清空id对应的覆盖物和驾车导航路径
        this._removeOverlays(id);
        this._removeDrivings(id);

        const overlays = [];
        const drivings = [];
        // 添加折线
        const polylinePoints = [start].filter(p => p && p.lng && p.lat).concat(points);
        if (polylinePoints.length > 1) {
            if (this.isPolyline) {
                this._drawPolyline(id, polylinePoints, options, overlays);
            } else {
                this._drawGuideLine(id, polylinePoints, options, overlays, drivings);
            }
        }

        if (start.lng && start.lat) {
            // 只有坐标值有效是才绘制
            // start label
            const startLabel = new BMapGL.Label('起', {
                position: new BMapGL.Point(start.lng, start.lat),
                offset: new BMapGL.Size(-10, -10)
            });
            // 自定义文本标注样式
            startLabel.setStyle({
                color: 'white',
                backgroundColor: options.color,
                fontSize: '16px',
                border: '2px solid white',
                borderRadius: '50%',
                height: '20px',
                width: '20px',
                lineHeight: '20px',
                textAlign: 'center',
                fontFamily: '微软雅黑'
            });
            overlays.push(startLabel);
        }

        // 添加地点文本标注
        for (const [idx, p] of points.entries()) {
            // 创建文本标注对象
            const labelText = p.lbxCount ? '菜' : String(idx + 1);
            const label = new BMapGL.Label(labelText, {
                position: new BMapGL.Point(p.lng, p.lat),
                offset: new BMapGL.Size(-10, -10)
            });
            // 自定义文本标注样式
            label.setStyle({
                color: 'white',
                backgroundColor: p.lbxCount ? 'salmon' : options.color,
                fontSize: '16px',
                border: '2px solid white',
                borderRadius: '50%',
                height: '20px',
                width: '20px',
                lineHeight: '20px',
                textAlign: 'center',
                fontFamily: '微软雅黑'
            });
            overlays.push(label);
        }

        this._addOverlays(id, overlays);
        this._addDrivings(id, drivings);

        this._expandViewport(id, polylinePoints);

        this.routes.set(id, {
            start,
            points,
            options
        });
    }

    // 画直线折线
    _drawPolyline(id, points, options, overlays) {
        const route = new BMapGL.Polyline(
            points.map(p => new BMapGL.Point(p.lng, p.lat)),
            { strokeColor: options.color, strokeWeight: 5, strokeOpacity: 1 }
        );
        // route.addEventListener('click', (e) => {
        //     this._fire('route-click', id);
        // });
        overlays.push(route);
    }

    // 使用百度地图的驾车导航功能画路径
    _drawGuideLine(id, points, options, overlays, drivings) {
        // 只绘制坐标有效的点
        for (const [idx, p] of points.slice(1).entries()) {
            const p1 = new BMapGL.Point(points[idx].lng, points[idx].lat);
            const p2 = new BMapGL.Point(p.lng, p.lat);

            if (p1.lng !== p2.lng || p1.lat !== p2.lat) {
                const driving = memoDrivingRoute(this.map, p1, p2, (polyline, memoPoints) => {
                    if (polyline) {
                        polyline.setStrokeColor(options.color);
                        overlays.push(polyline);
                        this.overlays.set(id, overlays);
                    } else {
                        this._drawPolyline(id, memoPoints, options, overlays);
                    }
                });
                driving && drivings.push(driving);
            }
        }
    }

    /// 清除路径
    removeRoute(id) {
        this._removeOverlays(id);
        this._removeDrivings(id);
        this._shrinkViewport(id);
        this.routes.delete(id);
    }

    /// 清除所有路径
    removeAllRoutes() {
        for (const id of this.routes.keys()) {
            this.removeRoute(id);
        }
    }

    _addOverlays(id, overlays) {
        for (const ol of overlays) {
            this.map.addOverlay(ol);
        }
        this.overlays.set(id, overlays);
    }

    _removeOverlays(id) {
        const overlays = this.overlays.get(id);
        if (Array.isArray(overlays)) {
            for (const ol of overlays) {
                this.map.removeOverlay(ol);
            }
        } else if (overlays) {
            this.map.removeOverlay(overlays);
        }
        this.overlays.delete(id);
    }

    _addDrivings(id, drivings) {
        this.drivings.set(id, drivings);
    }

    _removeDrivings(id) {
        const drivings = this.drivings.get(id);
        if (Array.isArray(drivings)) {
            for (const driving of drivings) {
                driving && driving.clearResults();
            }
        } else if (drivings) {
            drivings && drivings.clearResults();
        }
        this.drivings.delete(id);
    }

    _expandViewport(id, points) {
        this.viewportPoints.set(id, points);
        this._setViewport();
    }

    _shrinkViewport(id) {
        this.viewportPoints.delete(id);
        this._setViewport();
    }

    _setViewport() {
        const allVP = [];
        for (const ps of this.viewportPoints.values()) {
            allVP.push(...ps);
        }
        this.map.setViewport(allVP.filter(p => p && p.lng && p.lat));
    }
}

/// 记忆 百度地图的驾车导航功能画路径
/// 避免重复调用 driving 的 search 接口，提高路径绘制速度
const memoDrivingRoute = (() => {
    const memo = new Map();

    return (map, p1, p2, resultCallback) => {
        const key = `${p1.lng}-${p1.lat}--${p2.lng}-${p2.lat}`;

        if (memo.has(key)) {
            return resultCallback(null, memo.get(key));
        }

        const driving = new BMapGL.DrivingRoute(map, {
            renderOptions: {
                map: map,
                autoViewport: false
            },
            onMarkersSet: (pos) => {
                map.removeOverlay(pos[0].marker);
                map.removeOverlay(pos[1].marker);
            },
            onPolylinesSet: (routes) => {
                if (routes.length >= 1) {
                    for (const route of routes.slice(1)) {
                        map.removeOverlay(route.getPolyline());
                    }

                    const route = routes[0];
                    const polyline = route.getPolyline();
                    resultCallback(polyline, route._points);
                    memo.set(key, route._points);
                }
            }
        });
        driving.search(p1, p2);
        return driving;
    };
})();
